<template>
	<div v-if="textObject" class="whole-sentence">
		<div class ="user-info">
			<el-avatar :src="textObject.imageSrc"></el-avatar>
			<!-- <div class ="user-type">{{textObject.userType}}</div> -->
		</div>
		<div class ="user-sentence" v-html="textObject.content"></div>
	</div>
</template>

<script>
	export default {
		name: "Sentence",
		components: {},
		props: { 
			textObject:{
				type:Object,
				default: function() {return {}}
			},
		},
		mounted(){
		}
	}

</script>
<style scoped>
.el-avatar{
	width: 22px;
    height: 22px;
    line-height: 24px;
}
.whole-sentence{
	text-align: left;
	display: flex;
    line-height: 24px;
}
.user-info {
	display: flex;
	border-right: solid 1px #e0dede;
	width : 32px;
	line-height: 24px;
}
.user-sentence {
	/* display: flex; */
	width: calc(100% - 32px);
    padding-left: 8px;
}
</style>
